var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'popUpFrame '+(_vm.isOpen?'active':'')},[_c('div',{staticClass:"bg"}),(_vm.popType==2)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":"/img/car.gif"}}),_c('h3',[_vm._v("Loading...")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }